<template lang="pug">
    v-list-tile.grey.darken-4.white--text(style="height: 30px; padding-top: 4px;")
        v-layout(row style="height: 100%;")
            v-flex.xs2.text-sm-center CANTIDAD
            v-flex.xs7
                v-layout(row)
                    v-flex.xs6.text-sm-center ITEM
                    v-flex.xs2.text-sm-center PRECIO 
                    v-flex.xs2.text-sm-center DCTO
                    v-flex.xs2.text-sm-center SUBTOTAL
            v-flex.xs3.text-sm-center ACCIONES
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters('TransactionModule', {
            activeTransaction: 'activeTransaction'
        })
    }
}
</script>